import queryString from "query-string";
import isEmpty from "lodash/isEmpty";

export const API_CONFIG = {
  baseUrl: `${import.meta.env.VITE_APP_BASE_URL}`,
  socketUrl: `${import.meta.env.VITE_APP_SOCKET_URL}`,
  path: {
    login: "auth/login",
    logout: "auth/logout",
    signup: "auth/register",

    customer: "customer",
    customerAll: "customer/all",
    all_customer: "customer/other/details",
    customerCreate: "auth/register",
    customerUpdate: "customer/update",
    customerDelete: "auth/delete",
    customerRestore: "auth/restore",
    customerWallet: "customer/wallet/details",

    curator: "curator",
    curator_all: "curator/all",
    curatorTrash: "auth/delete",
    curatorRestore: "auth/restore",
    curatorUpdate: "curator/update",

    agent: "agent/all",
    agentCreate: "auth/register",
    agentTrash: "auth/delete",
    agentUpdate: "agent/update",
    getAgent: "agent",

    ai_request: "ai-request/all",
    ai_request_info_get: "ai-request",
    single_airequest: "itinerary/agent-itineraries",
    itinerary_update: "itinerary/agent-itineraries/update",
    itinerary_submit: "itinerary/agent-itineraries/create",
    assign_curator_list: "ai-request/assign-curator-list",
    assign_curator: "ai-request/assign-curator",

    agent_category: "agent-itinerary-management/itineraries",
    assign_gold_agent: "agent-itinerary-management/assign-gold-agent",

    get_countries: "offer/countries",

    itinerary_all: "itinerary/all",
    itinerary_update_status: "itinerary/update-status",
    itinerary_info_create: "itinerary/create",
    itinerary_info_update: "itinerary/update",
    itinerary_info_delete: "itinerary/delete",
    itinerary_restore: "itinerary/restore",
    itinerary_info_get: "itinerary",
    itinerary_day: "itinerary/day/by-itinerary",
    add_itinerary_day: "itinerary/day/create",
    delete_itinerary_day: "itinerary/day/delete",
    drag_itinerary_day: "itinerary/day/bulk-update",
    update_itinerary_day: "itinerary/day/update",
    add_itinerary_activity: "itinerary/activity/create",
    update_itinerary_activity: "itinerary/activity/update",
    delete_itinerary_activity: "itinerary/activity/delete",
    itinerary_package_create: "packages/create",
    itinerary_package_get: "packages/all",
    itinerary_package_delete: "packages/delete/{id}",

    offer_all: "offer/all",
    offerCreate: "offer/create",
    offerDelete: "offer/delete",
    offerClaim: "offer/reedem-offer",

    cashback_data: "cashback/all",

    notification_list: "notification/list",
    notification_create: "notification/send",
    notification_user: "notification/get-users",
    notification_read: "notification/read",
    notification_delete: "notification/delete",

    settings_cashback: "setting",
    other_itinerary_details: "itinerary/other-details",

    // Group Packages
    group_package_all: "group-packages/all",
    group_package_create: "group-packages/create",
    group_package_update: "group-packages/update",
    group_package_delete: "group-packages/delete",
    group_package_restore: "group-packages/restore",
    group_package_get: "group-packages",
    group_package_update_status: "group-packages/update-status",
    group_package_other_details: "group-packages/other-details",
    // Group Package Days
    group_package_day: "group-packages/day/by-group-package",
    group_package_day_create: "group-packages/day/create",
    group_package_day_update: "group-packages/day/update",
    group_package_day_delete: "group-packages/day/delete",
    group_package_day_reorder: "group-packages/day/bulk-update",
    // Group Package Activities
    group_package_activity_create: "group-packages/activity/create",
    group_package_activity_update: "group-packages/activity/update",
    group_package_activity_delete: "group-packages/activity/delete",

    image_upload: "file-upload/single",

    // Country Management
    country_all: "country/all",
    country_create: "country/create",
    country_update: "country/update",
    country_delete: "country/delete",

    // Category Management
    category_all: "category/all",
    category_create: "category/create",
    category_delete: "category/delete",

    WalletTransaction: "payment/all",
    CreditAmount: "payment/wallet/credit",

    updateDeviceToken: "auth/update",

    forgotPasswordSendMail: "auth/send-forgot-password-mail",
    forgotPassword: "auth/forgot-password",

    get_profile: "auth/me",
    profile_update: "auth/update",
  },
  sentry: "https://c1308bc472d740f78185cffc17485c87@sentry.io/1483874",
};

export const User_Role = {
  admin: "ADMIN",
  agent: "AGENT",
  curator: "CURATOR",
  customer: "CUSTOMER",
} as const;

export const getUrl = (
  url: string,

  params: { [key: string]: any } = {}
): string => {
  let urlString = `${API_CONFIG.baseUrl}/${url}`;
  if (params && !isEmpty(params)) {
    urlString += `?${queryString.stringify(params)}`;
  }
  return urlString;
};

export type UserRole = (typeof User_Role)[keyof typeof User_Role];
